export default __webpack_public_path__ + "static/media/projectoA.756c2c1e.jpg";